<template>
  <div class="how_it_works">
    <div class="how_it_works_header" :style="{height: headerHeight+'px'}">
      <div class="how_it_works_future">How it works</div>
    </div>

    <div class="how_it_works_about">
      <div>
        <h3>About staking</h3>
        <p>Staking is only available at Proof of Stake blockchains.It is a process that involves committing your crypto assets to support a blockchain network and confirm transactions. In exchange for that, you earn rewards calculated in percentage yields.</p>
      </div>
    </div>
    <div class="how_it_works_list">
      <ul>
        <li>
          <div class="how_it_works_list_msg" style="text-align: right;">
            <h4>Validators run the infrastructure</h4>
            <p>Validators are special nodes responsible for the provision of infrastructure as well as proposing and validating new blocks and appending them to the blockchain.</p>
          </div>
          <div class="how_it_works_list_border"><span></span></div>
          <div class="how_it_works_list_img">
            <img src="../../static/images/how_it_works/01.png" alt="">
          </div>
        </li>
        <li>
          <div class="how_it_works_list_img">
            <img src="../../static/images/how_it_works/02.png" alt="">
          </div>
          <div class="how_it_works_list_border"><span></span></div>
          <div class="how_it_works_list_msg" style="text-align: left;">
            <h4>Crypto holders delegate the token</h4>
            <p>Crypto holders can delegate the token to a validator of your choice, and help secure the blockchain network. In return, you earn staking rewards.</p>
          </div>
        </li>
        <li>
          <div class="how_it_works_list_msg" style="text-align: right;">
            <h4>Validators earn staking fees</h4>
            <p>Validators earn a certain fee from the delegators' staking rewards for providing staking infrastures.</p>
          </div>
          <div class="how_it_works_list_border"><span></span></div>
          <div class="how_it_works_list_img">
            <img src="../../static/images/how_it_works/03.png" alt="">
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      headerHeight: 996
    }
  },
  created () {
    if ($(window).width() <= 700) {
      this.headerHeight = 400
    } else {
      this.headerHeight = $(window).height() - 90
    }
    $(window).resize(() => {
      if ($(window).width() <= 700) {
        this.headerHeight = 400
      } else {
        this.headerHeight = $(window).height() - 90
      }
    })
  },
  mounted () {
  },
  methods: {
    toUrl: function (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    }
  }
}
</script>

<style scoped>
.how_it_works{
  background-color: #FFFFFF;
}
.how_it_works_header{
  background-color: #171A17;
  position: relative;
}
.how_it_works_future{
  width: 100%;
  font-size: 100px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #2E9728;
  text-shadow: 0px 2px 1px #000000;
  text-align: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.how_it_works_about{
  background-color: #F5FAF5;
}
.how_it_works_about div{
  display: flex;
  flex-wrap: wrap;
  margin: auto;
  padding: 116px 0 106px 0;
  justify-content: center;
}
.how_it_works_about div h3{
  font-size: 40px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #303030;
  text-shadow: 0px 2px 2px #A9A9A9;
  margin-right: 100px;
}
.how_it_works_about div p{
  max-width: 833px;
  font-size: 20px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #303030;
}
.how_it_works_list{
  padding: 50px 20px;
}
.how_it_works_list ul{
  max-width: 1000px;
  margin: 0 auto;
}
.how_it_works_list ul li{
  display: flex;
  justify-content: center;
}
.how_it_works_list ul li img{
  max-width: 300px;
  width: 100%;

}
.how_it_works_list_img{
  flex: 1;
  padding: 50px 50px 80px 50px;
  text-align: center;
}
.how_it_works_list_msg{
  flex: 1;
  padding: 50px 50px 80px 50px;
}
.how_it_works_list_msg h4{
  font-size: 24px;
  font-family: 'PingFangSC-Medium';
  font-weight: 800;
  color: #303030;
  margin-bottom: 25px;
}
.how_it_works_list_msg p{
  max-width: 450px;
  display: inline-block;
  font-size: 16px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #535353;
}
.how_it_works_list_border{
  width: 6px;
  background-color: #2E9728;
  position: relative;
}
.how_it_works_list_border span{
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
  width: 26px;
  height: 26px;
  background-color: #ffffff;
  border: 6px solid #2E9728;
}
@media (max-width: 1212px) {
  .how_it_works_about div{
    display: block;
  }
  .how_it_works_about div h3{
    margin: 0 0 30px 0;
    text-align: center;
  }
  .how_it_works_about div p{
    margin: 0 auto;
    padding: 20px;
    text-align: center;
  }
}
@media (max-width: 1200px) {
  .how_it_works_future{
    font-size: 100px;
  }
}
@media (max-width: 960px) {
  .how_it_works_future{
    padding: 0 50px;
  }
}
@media (max-width: 720px) {
  .how_it_works_future{
    font-size: 65px;
  }
  .how_it_works_list ul li{
    flex-direction: column;
    margin-bottom: 40px;
  }
  .how_it_works_list ul li:first-child, .how_it_works_list ul li:last-child{
    flex-direction: column-reverse;
  }
  .how_it_works_list_border{
    display: none;
  }
  .how_it_works_list_msg,.how_it_works_list_img{
    width: 100%;
    text-align: center !important;
    padding: 0;
    margin-bottom: 40px;
  }
  .how_it_works_list_msg h4{
    text-align: center !important;
  }
  .how_it_works_list_msg p{
    text-align: center !important;
    font-size: 16px;
  }
  .how_it_works_list_msg h4{
    text-align: left;
    font-size: 18px;
    margin-bottom: 20px;
  }
  .how_it_works_list_msg p{
    text-align: left;
  }
  .how_it_works_about div h3{
    font-size: 30px;
  }
  .how_it_works_about div{
    padding: 40px 20px;
  }
  .how_it_works_about div p{
    font-size: 18px;
  }
}
@media (max-width: 634px) {
  .how_it_works_future{
    font-size: 50px;
  }
}
@media (max-width: 360px) {
  .how_it_works_future{
    padding: 0 20px;
    font-size: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/how_it_works.vue